import React, { useState, useEffect } from 'react'

import { Event } from '@mui/icons-material'
import { Button, Col, Input, Row, SelectForm, TimePicker } from 'components'
import { DeleteIcon } from 'components/Icons'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { SPACING } from 'utils'

import { IPeriocidadeComponent } from '../Diario/Diario'
import { ModalDatas } from './components'
// import { Container } from './styles';

const Acionador: React.FC<IPeriocidadeComponent> = ({
  control,
  periodicidade,
  listOptions,
  onSubmitPeriodicidade,
  setValue,
  acionador
}) => {
  const [modalDatas, toggleModalDatas] = useToggle()
  const [indexList, setIndexList] = useState<number | undefined>()
  // LISTA hora DO COMPONENTE
  const [listAcionador, setListAcionador] = useState([
    {
      data: [],
      hora: new Date(),
      id: 0
    }
  ])
  // ENVIO DOS DADOS DO COMPONENTE PARA MODAL

  // NOVA LINHA DE hora
  const handleNewItem = () => {
    setListAcionador([
      ...listAcionador,
      {
        data: [],
        hora: new Date(),
        id: listAcionador[listAcionador.length - 1].id + 1
      }
    ])
  }
  // UPDATE DO hora NA LISTA hora
  const handleTimePicker = (time, index) => {
    const cpyArr = listAcionador.slice()
    cpyArr[index].hora = time
    setListAcionador(cpyArr)
    setValue('acionador', cpyArr)
  }

  // DELETAR hora ADICIONADO
  const handleDelete = (id: number) => {
    const cpyArr = listAcionador.slice()
    setListAcionador(cpyArr.filter((hr) => hr.id !== id))
    setValue(
      'acionador',
      cpyArr.filter((hr) => hr.id !== id)
    )
  }

  const handleClean = () => {
    setListAcionador([{ data: [], hora: new Date(), id: 0 }])
  }

  // ! MODAL

  const [listDatas, setListDatas] = React.useState([
    {
      data: new Date(),
      id: 0
    }
  ])

  // ADD DATA NO MODAL
  const handleDatePicker = (date, index) => {
    const cpyArr = listDatas.slice()
    cpyArr[index].data = date
    setListDatas(cpyArr)
    // setValue("acionador",cpyArr)
  }

  // NOVA LINHA DE DATA NO MODAL
  const handleNewDataItem = () => {
    setListDatas([
      ...listDatas,
      { data: new Date(), id: listDatas[listDatas.length - 1].id + 1 }
    ])
  }

  // DELETA DATA NO MODAL
  const handleDataDelete = (id: number) => {
    const cpyArr = listDatas.slice()
    setListDatas(cpyArr.filter((hr) => hr.id !== id))
    setValue(
      'acionador',
      cpyArr.filter((hr) => hr.id !== id)
    )
  }

  // FINALIZA MODAL
  const handleDatas = () => {
    const cpyArr = listAcionador.slice()
    cpyArr[indexList].data = listDatas
    setListAcionador(cpyArr)
    toggleModalDatas()
    setListDatas([
      {
        data: new Date(),
        id: 0
      }
    ])
    setValue('acionador', cpyArr)
  }

  useEffect(() => {
    if (acionador) {
      const value = acionador.map((acionador, index) => {
        const formatAcionador = acionador
        formatAcionador['id'] = index
        formatAcionador.hora = moment(acionador.hora, 'HH:mm:ss')
        return formatAcionador
      })
      setListAcionador(value)
    }
  }, [])

  return (
    <Col>
      <Row alignItems="center" justifyContent="start">
        <Col>
          <SelectForm
            defaultValue={periodicidade}
            control={control}
            listOptions={listOptions}
            label="Tipo"
            width="160px"
            formValue="tipo"
          />
        </Col>
        {/* <Col marginLeft={SPACING.spacing15}> */}
        {/*   {listAcionador.map((diario, index) => { */}
        {/*     let datas = "" */}
        {/*     if (diario.data.length > 0) { */}
        {/*       diario.data.forEach( */}
        {/*         (dt) => (datas += `${moment(dt.data).format("L")} - `) */}
        {/*       ) */}
        {/*     } */}
        {/*     return ( */}
        {/*       <Col key={index} marginBottom={SPACING.spacing10}> */}
        {/*         <Row alignItems="center" justifyContent="start"> */}
        {/*           <Col marginRight={SPACING.spacing15}> */}
        {/*             <div */}
        {/*               onClick={() => { */}
        {/*                 toggleModalDatas() */}
        {/*                 setIndexList(index) */}
        {/*                 if (diario.data.length > 0) setListDatas(diario.data) */}
        {/*               }} */}
        {/*             > */}
        {/*               <Input */}
        {/*                 label="Data" */}
        {/*                 value={datas} */}
        {/*                 width="482px" */}
        {/*                 inputIcon={<Event />} */}
        {/*               /> */}
        {/*             </div> */}
        {/*           </Col> */}
        {/*           <Col marginRight={SPACING.spacing20}> */}
        {/*             <TimePicker */}
        {/*               label="Horário" */}
        {/*               value={moment(diario.hora).toDate()} */}
        {/*               onChange={(data) => handleTimePicker(data, index)} */}
        {/*             /> */}
        {/*           </Col> */}

        {/*           {listAcionador.length - 1 === index ? ( */}
        {/*             <Button text="+" onClick={handleNewItem} /> */}
        {/*           ) : ( */}
        {/*             <DeleteIcon onClick={() => handleDelete(diario.id)} /> */}
        {/*           )} */}
        {/*         </Row> */}
        {/*       </Col> */}
        {/*     ) */}
        {/*   })} */}
        {/* </Col> */}
      </Row>
      <Row alignItems="center" justifyContent="end">
        <Button text="Limpar" onClick={handleClean} variantButton="text" />
      </Row>
      <ModalDatas
        isOpen={modalDatas}
        toggleModal={toggleModalDatas}
        listDatas={listDatas}
        onSubmitModal={handleDatas}
        handleDatePicker={handleDatePicker}
        handleNewItem={handleNewDataItem}
        handleDelete={handleDataDelete}
      />
    </Col>
  )
}

export default Acionador
